
  <div class="row">
    <div class="col-lg-12 grid-margin">
      <div class="card">
        <div class="card-body upper-header">
            <div class="row">
                <div class="form-group col-2 ">
                  <label>From Date (Reg. Date)</label>
                  <input class="form-control border-primary" [max] = "to_date" [owlDateTime]="dt" placeholder="Date" name="from_date"
                    [(ngModel)]="from_date" readonly>
                  <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                  <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                </div>
                <div class="form-group col-2 ">
                    <label>To Date (Reg. Date)</label>
                    <input class="form-control border-primary" [min]="from_date" [max] = "maxDate" [owlDateTime]="dt1" placeholder="Date" name="to_date"
                      [(ngModel)]="to_date" readonly>
                    <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
                    <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                </div>

                <div class="form-group col-2 ">
                  <label >Darshan Type</label>
                  <select class="form-control border-primary"   name="darshan_type_id" [(ngModel)]="darshan_type_id">
                    <option [value]="''">select</option>
                    <option *ngFor="let data of allDarshanTypes" [value]="data.id">{{data.name}}</option>
                  </select>
                </div>

                <div class="form-group col-2">
                  <label >Department</label>
                  <select class="form-control border-primary"  name="department_id" [(ngModel)]="department_id">
                    <option [value]="''">select</option>
                    <option *ngFor="let data of allDepartments" [value]="data.id">{{data.name}}</option>
                  </select>
                </div>


                <div class="form-group col-1.5">
                  <button type="button" style="margin-top: 30px;" class="btn btn-inverse-primary btn-fw top-btn-head" (click)="getList($event)">Load</button>
                </div>
              </div>
          <h4 class="card-title">
            <div class="d-flex bd-highlight">
              <div class="p-2 flex-grow-1 bd-highlight">Visitors Detail By Ref Person - 7.00 PM</div>
              <div class="p-2 bd-highlight" *ngIf = "permissionsService.checkPermission('read_export_late_registrations_ref_counts')"><button  type="btn"  class="btn btn-primary btn-fw" (click) = "export()">Export</button>
              </div>
            </div>
          </h4>
          <div class="table-responsive"  *ngIf="visitors_detail && visitors_detail.data && visitors_detail.data.length">
            <table class="table">
              <thead>
              <tr>
                <th>S.No</th>
                <th>Date Time Of Registration</th>
                <th>Date of Visit</th>
                <th>Time of Visit</th>
                <th>Name</th>
                <th>Gender</th>
                <th>Mobile Number</th>
                <th>Id Proof Type</th>
                <th>Id Proof Number</th>
                <th>Darshan Type</th>
                <th>Department</th>
                <th>Referred By</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let data of visitors_detail?.data; let i = index">
                <td>
                  <span *ngIf = "page == 1">{{i+1}}</span>
                  <span *ngIf = "page > 1">{{((page - 1 )*perPage) + (i+1)}}</span>
                </td>
                <td>{{data?.regDateTime}}</td>
                <td>{{data?.date}}</td>
                <td>{{data?.registration?.time_of_visit}}</td>
                <td>{{data?.name}}</td>
                <td>{{data?.gender}}</td>
                <td>{{data?.registration?.mobile_no}}</td>
                <td>{{data?.id_proof_type?.name}}</td>
                <td>{{data?.id_proof_number}}</td>
                <td>{{data?.registration?.darshan_type?.name}}</td>
                <td>{{data?.registration?.reference_department?.name}}</td>
                <td>
                  <span *ngIf = "data?.registration">{{data?.registration?.reference?.name}}</span>
                  <span *ngIf = "data?.registration?.reference_person_name">{{data?.registration?.reference_person_name}}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="p-12" *ngIf="visitors_detail && visitors_detail.data && !visitors_detail.data.length">
            <span class="ng-star-inserted no_data" >No Data found.</span>
          </div>
          <ngb-pagination  *ngIf="visitors_detail && visitors_detail.data && visitors_detail.data.length" [collectionSize]="totalCount" [pageSize]="perPage"
          [(page)]="page" (pageChange)="getList('pagination')" [maxSize]="3"
          class="pull-right justify-content-end page-mt-10"
          aria-label="Default pagination"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>

